"use strict"
exports.__esModule = true;
exports.OutlinedIdBadgeIconConfig = {
  name: 'OutlinedIdBadgeIcon',
  height: 512,
  width: 384,
  svgPath: 'M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z',
  yOffset: 0,
  xOffset: 0,
};
exports.OutlinedIdBadgeIcon = require('../createIcon').createIcon(exports.OutlinedIdBadgeIconConfig);
exports["default"] = exports.OutlinedIdBadgeIcon;